import { AlertDescriptionMultiAnalysisProps } from "../../@types";
import AlertDescriptionSampleLink from "../AlertDescriptionSampleLink";
import { ALERT_TYPES_MAP } from "../../../alertsconfiguration/const";

const AlertDescriptionThreatIntelligence = ({
  type,
  data,
  linksReloadDocument,
  onLinkClick
}: AlertDescriptionMultiAnalysisProps) => (
  <>
    Threat Intelligence Analysis{" "}
    <AlertDescriptionSampleLink
      data={data}
      linksReloadDocument={linksReloadDocument}
      onLinkClick={onLinkClick}
    />{" "}
    {type === ALERT_TYPES_MAP.SPECTRA_INTELLIGENCE_UPLOAD_COMPLETE
      ? `has started`
      : "has finished"}
    .
  </>
);

export default AlertDescriptionThreatIntelligence;
